import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface EmailConfig {
  to: string[];
  subject: string;
  html: string;
  text?: string;
  pdfStoragePath?: string; // Optional path to PDF in Firebase Storage for backend attachment
}

export const sendEmail = async (emailConfig: EmailConfig): Promise<void> => {
  console.log('sendEmail function called with config:', {
    to: emailConfig.to,
    subject: emailConfig.subject,
    hasHtml: !!emailConfig.html,
    hasText: !!emailConfig.text
    // pdfStoragePath removed
  });

  try {
    // Log the transformation of email addresses
    console.log('Transforming email addresses:', {
      original: emailConfig.to,
      transformed: emailConfig.to.map(email => ({ email }))
    });

    // Format the email data for the emails collection
    const emailData = {
      to: emailConfig.to.map(email => ({ email })),
      from: {
        email: "noreply@berwickcamp.org",
        name: "Berwick Registrar"
      },
      subject: emailConfig.subject,
      html: emailConfig.html,
      text: emailConfig.text || emailConfig.html.replace(/<[^>]*>/g, ''), // Strip HTML if text version not provided
      status: 'pending',
      createdAt: serverTimestamp()
      // pdfStoragePath removed
    };

    console.log('Creating email document with data:', JSON.stringify(emailData, null, 2));

    // Create the document in the emails collection
    const docRef = await addDoc(collection(db, 'emails'), emailData);
    console.log('Email document created successfully with ID:', docRef.id);

  } catch (error: any) {
    console.error('Failed to create email document:', error);
    throw new Error(error.message || 'Failed to create email document');
  }
};

// Helper function to send a test email
export const sendTestEmail = async (toEmail: string): Promise<void> => {
  const testEmailConfig: EmailConfig = {
    to: [toEmail],
    subject: 'Test Email from Berwick Camp Registration',
    html: `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <title>Test Email from Berwick Camp</title>
        </head>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
          <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
            <h1 style="color: #2c3e50;">Test Email</h1>
            <p>This is a test email from your Berwick Camp Registration system.</p>
            <p>If you received this email, your email configuration is working correctly!</p>
            <p>Time sent: ${new Date().toISOString()}</p>
            <hr style="border: 1px solid #eee; margin: 20px 0;">
            <p style="font-size: 12px; color: #666;">
              This is an automated message from Berwick Camp Registration System.
              Please do not reply to this email.
            </p>
          </div>
        </body>
      </html>
    `,
    text: `Test Email from Berwick Camp Registration System

This is a test email from your Berwick Camp Registration system.
If you received this email, your email configuration is working correctly!

Time sent: ${new Date().toISOString()}

This is an automated message. Please do not reply to this email.`
  };

  console.log('Test email config:', testEmailConfig);
  await sendEmail(testEmailConfig);
}; 